import { toast } from 'sonner';

import { clearCart } from '@/entities/cart/model';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/shared/components/ui/alert-dialog';
import { Button } from '@/shared/components/ui/button';

export const ClearCartDialog = () => {
  const handleClearCart = () => {
    clearCart();
    toast.success('Корзина очищена');
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger>
        <Button variant="destructive">Очистить корзину</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Вы уверены?</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-500">
            Все товары будут безвозвратно удалены из корзины.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction className="bg-destructive text-white hover:bg-destructive/80" onClick={handleClearCart}>
            Продолжить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
